import React, { useState, useEffect } from "react";

const GradientTextWithStroke = ({
  text = "Play The Games",
  desktopFontSize = 50,
  mobileFontSize = 30,
  strokeColor = "#5c2d06",
  strokeWidth = 4,
  gradientStops = [
    { offset: "25%", color: "#FAECA4" },
    { offset: "100%", color: "#B5763A" },
  ],
}) => {
  const [fontSize, setFontSize] = useState(desktopFontSize);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setFontSize(mobileFontSize);
      } else {
        setFontSize(desktopFontSize);
      }
    };

    handleResize(); // initial check
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [desktopFontSize, mobileFontSize]);

  return (
    <svg
      width="100%"
      height={fontSize * 2}
      viewBox={`0 0 700 ${fontSize * 2}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="textGradient" x1="0%" y1="0%" x2="0%" y2="100%">
          {gradientStops.map(({ offset, color }, idx) => (
            <stop key={idx} offset={offset} stopColor={color} />
          ))}
        </linearGradient>
      </defs>

      <text
        x="50%" // Center horizontally
        y={fontSize * 1.4} // Slight vertical alignment
        textAnchor="middle" // Center text on x position
        fontFamily="'Barlow', sans-serif"
        fontSize={fontSize}
        fontWeight="bold"
        fill="url(#textGradient)"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        paintOrder="stroke fill"
        dominantBaseline="middle" // optional for vertical centering
      >
        {text}
      </text>
    </svg>
  );
};

export default GradientTextWithStroke;
